export default __webpack_public_path__ + "static/media/logo.a27c981d.png";